export const formatTextAndUnicode = (text) => {
  if (!text || typeof text !== "string") return text;
  try {
    return text.replace(/\\+u([0-9a-fA-F]{4})/gi, (match, hexCode) => {
      return String.fromCharCode(parseInt(hexCode, 16));
    });
  } catch (error) {
    return text;
  }
};
